module.exports = __webpack_public_path__ + "static/openathens-bf94f79a762e834200702625600cb9b9.jpg";